import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import selfDirectives from './num-format'


export const global = {
TransferDom,
...selfDirectives
}


export const local = {
TransferDom,
...selfDirectives
}



// WEBPACK FOOTER //
// ./src/directives/index.js